module.exports = __webpack_public_path__ + "static/img/VAVA.da5c4bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/VAVA.jpg
// module id = FwiE
// module chunks = 1